import { connect } from 'react-redux'
import { checkJiaban } from './actions'
import Setting from './main'


const mapDispatchToProps = {
    checkJiaban
}
const mapStateToProps = (state) => {
  return {
    ...state.JiabanCheck
  }
}
  

export default connect(mapStateToProps, mapDispatchToProps)(Setting)
